var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFF;}\n\t.st1{fill:#FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 71,
    width: 85,
    x: 45.9,
    y: 224.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    height: 73.3,
    width: 87.3,
    x: 381.9,
    y: 290.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 279.7,
    width: 62.6,
    x: 224.7,
    y: 197.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M439.3,422.9h-81.3c-3.9,0-7,3.1-7,7s3.1,7,7,7h81.3c3.9,0,7-3.1,7-7S443.1,422.9,439.3,422.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st1",
    d: "M346.2,378V197.7h-44.8v279.7H489V378H346.2z M469.2,429.9c0,13.8-11.2,25-25,25H353c-13.8,0-25-11.2-25-25v0   c0-13.8,11.2-25,25-25h91.1C458,404.9,469.2,416.1,469.2,429.9L469.2,429.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st1",
    d: "M165.8,309.4H23v168.1h187.7V197.7h-44.8V309.4z M184.6,362.6c0,13.8-11.2,25-25,25H68.4   c-13.8,0-25-11.2-25-25s11.2-25,25-25h91.1C173.4,337.6,184.6,348.8,184.6,362.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M73.3,355.6c-3.9,0-7,3.1-7,7s3.1,7,7,7h81.3c3.9,0,7-3.1,7-7s-3.1-7-7-7H73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st1",
    d: "M188.6,111.4c-0.3,0-0.6,0-0.9,0l21.4,51.2c-4.7,6.2-8.1,13.4-10,21.1h113.9c-0.6-2.7-1.5-5.3-2.5-7.8   l32.1-53.9c-13.2-1.6-25-9-32.3-20l-31.2,41.7c-7.1-3-14.8-4.7-22.9-4.7c-3.2,0-6.4,0.3-9.5,0.8l-24-43.7   C214,105.7,201.6,111.4,188.6,111.4C188.6,111.4,188.6,111.4,188.6,111.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 188.6,
    cy: 66,
    r: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M180.3,96.3c0.4,0.1,0.8,0.2,1.2,0.3c13.3,3.1,26.7-2.8,33.6-13.9c1.6-2.6,2.9-5.4,3.7-8.5   c4.6-16.7-5.3-34-22-38.6c-14-3.8-28.3,2.4-35.3,14.3c-1.4,2.4-2.5,5-3.3,7.7c-2.3,8.4-1,16.9,3,23.8   C165.3,88.5,171.9,94,180.3,96.3z M188.6,54.6c6.3,0,11.4,5.1,11.4,11.4s-5.1,11.4-11.4,11.4s-11.4-5.1-11.4-11.4   S182.3,54.6,188.6,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st1",
    d: "M59.7,159.7c2.8,3.9,6.4,6.8,10.4,8.8c1.8,0.9,3.6,1.5,5.5,2v25.9c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7v-25.9   c2.1-0.6,4.3-1.4,6.3-2.4c1.1-0.6,2.3-1.3,3.4-2.1c9.5-6.9,13.5-18.7,10.9-29.5l52.4-33.3c-5.4-3.8-10-8.8-13.4-14.8   c-1.8-3.1-3.1-6.3-4.1-9.6l-49.9,38.9c-3.9-1.9-8.2-2.9-12.6-2.9c-5.8,0-11.6,1.8-16.6,5.4c-1.2,0.9-2.4,1.9-3.4,2.9   c-6.5,6.5-9.3,15.7-7.9,24.5C55.3,151.8,57,156,59.7,159.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st1",
    d: "M347.7,79.5c1.4,0.2,2.8-0.8,3-2.2c0,0,0,0,0,0c0.1-0.7-0.1-1.4-0.5-1.9c-0.4-0.6-1-0.9-1.7-1   c-0.1,0-0.2,0-0.4,0c-0.6,0-1.1,0.2-1.6,0.5c-0.6,0.4-0.9,1-1,1.7c-0.1,0.7,0.1,1.4,0.5,1.9C346.3,79.1,347,79.4,347.7,79.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st0",
    d: "M319.3,89.8c5.3,11.9,17.8,19.6,31.4,18.5c0.4,0,0.8-0.1,1.3-0.1c8.6-1.1,16-5.6,20.9-11.9   c4.9-6.3,7.4-14.6,6.3-23.2c-0.4-2.9-1.1-5.6-2.2-8.1c-5.3-12.8-18.6-20.9-33-19.1c-17.2,2.2-29.4,17.9-27.2,35.1   C317.3,84,318.1,87,319.3,89.8z M336.8,75.3c0.9-6.2,6.7-10.6,12.9-9.7c6.2,0.9,10.6,6.7,9.7,12.9c-0.4,3-2,5.7-4.4,7.5   c-2,1.5-4.4,2.3-6.8,2.3c-0.5,0-1.1,0-1.6-0.1c-3-0.4-5.7-2-7.5-4.4S336.3,78.4,336.8,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    className: "st1",
    d: "M404.8,148.4l11,9.4c-4.1,10.3-1.8,22.5,6.6,30.7c1,0.9,2,1.8,3,2.5c3,2.2,6.2,3.7,9.7,4.5l0,14.3l0,11.6   c0,3.9,3.1,7,7,7c0,0,0,0,0,0c3.9,0,7-3.1,7-7l0-11.6l0-14.3c0.6-0.2,1.2-0.3,1.8-0.5c4.2-1.4,8.2-3.8,11.6-7.2   c3.2-3.3,5.4-7.2,6.7-11.3c2.6-8.5,1.2-18-4.4-25.4c-0.9-1.2-1.9-2.3-3-3.3c-7.8-7.6-18.9-9.7-28.5-6.6l-10.4-10.8l-33.5-34.8   c-1.4,3.2-3.3,6.2-5.4,9c-4.2,5.4-9.4,9.7-15.3,12.7L404.8,148.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomacao);
export default __webpack_public_path__ + "static/media/automacao.ac98ebece7cf4327d59f473347a735c9.svg";
export { ForwardRef as ReactComponent };